import { createElement } from 'react'
import RDSOptimization from '~/dashboard/aws_master_optimizations/rds_optimization'
import ReactController from './react_controller'

export default class AWSRdsOptimizationController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
    masterOptimizationStatus: String,
  }

  createComponent() {
    return createElement(RDSOptimization, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
      masterOptimization: {
        id: this.masterOptimizationIdValue,
        status: this.masterOptimizationStatusValue,
      },
    })
  }
}
